export default function(height) {

    this._options.height = height;

    return this;
};
